import React from 'react';
import '../../css/cards/Membership.css';

import { AiFillQuestionCircle } from 'react-icons/ai';
import { useDispatch } from 'react-redux';

import { openTrainingMore } from '../../features/training';

const Membership = ({
	image,
	icon,
	title,
	price,
	price_before,
	urls,
	items,
}) => {
	const dispatch = useDispatch();

	return (
		<div className='Membership'>
			<div className='membership-header'>
				<img src={image} alt='Header Membership' />
			</div>
			<div className='membership-body'>
				<div className='membership-info'>
					<div className='membership-icon'>
						<img src={icon} alt='Membership Icon' />
					</div>
					<div className='membership-name'>
						<h4
							style={
								title === 'Full Plan'
									? { color: '#6000de' }
									: { color: '#000000' }
							}
						>
							{title}
						</h4>
						<h5>
							${price} USD
							<sup>${price_before}USD</sup>
						</h5>
					</div>
				</div>

				<ul className='membership-card-items'>
					{items.map((e, i) => (
						<li
							key={i}
							style={
								e.item === 'Acceso adicional al campamento.'
									? { textAlign: 'center' }
									: { textAlign: 'center' }
							}
						>
							{e.item}
							{e.more ? (
								<AiFillQuestionCircle
									className='question-icon'
									onClick={() => {
										dispatch(
											openTrainingMore({
												modal: true,
												title: e.item,
												more: e.more,
											})
										);
									}}
								/>
							) : null}
						</li>
					))}
				</ul>
				<div className='membership-button'>
					{/* <a
                        href={urls[0].url}
                        target={"_blank"}
                        rel="noreferrer"
                        className="paypal"
                    >
                        {urls[0].name}
                    </a> */}
					<a
						href={urls[1].url}
						target={'_blank'}
						rel='noreferrer'
						className='card'
					>
						{urls[1].name}
					</a>
				</div>
			</div>
		</div>
	);
};

export default Membership;
